import React from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { closeModal } from '../../store/modal/modal'
import { AddAgentResultToCRMModal } from '../../apps/professional-app/fa/MeetingSummary/MeetingSummaryAgent/Header/CRMModal/AddAgentResultToCRMModal'
import { UpdateExternalMeetingContactModal } from '../../views/UpdateExternalContact/UpdateExternalContact'
import { TaskSourceType } from '../../views/Tasks/hooks'
import { AddTaskToCRMModal } from '../../views/MeetingSummary/CRM/V2/AddTaskToCRMModal'

export const MeetingSummaryModalManager: React.FC = () => {
  const dispatch = useAppDispatch()
  const modals = useAppSelector((state) => state.modal.modals)

  return (
    <>
      {modals.map((modal) => {
        const { id, type, serviceId, user, roomSession, tasks, externalIntegration } = modal

        if (!type || !serviceId) {
          return null
        }

        switch (type) {
          case 'exportMeeting':
            if (!roomSession) {
              return null
            }

            return <AddAgentResultToCRMModal key={id} roomSession={roomSession} show={true} onHide={() => dispatch(closeModal(id))} serviceId={serviceId} />

          case 'updateContact':
            if (!user) {
              return null
            }

            return (
              <UpdateExternalMeetingContactModal
                key={id}
                show={true}
                user={user}
                serviceId={serviceId}
                onCancel={() => dispatch(closeModal(id))}
                // No action needed on save in this context; empty function is intentional.
                onSave={() => {}}
              />
            )

          case 'createTask':
            if (!roomSession || !tasks || !externalIntegration) {
              return null
            }

            return (
              <AddTaskToCRMModal
                key={id}
                show={true}
                onHide={() => dispatch(closeModal(id))}
                tasks={tasks}
                userIntegration={externalIntegration}
                baseTaskDueDate={roomSession.finishedAt ? new Date(roomSession.finishedAt) : null}
                taskContextDetails={{ roomId: roomSession.roomId, sessionId: roomSession.id }}
                type={TaskSourceType.MEETING}
                roomSession={roomSession}
              />
            )

          default:
            return null
        }
      })}
    </>
  )
}
